/*
  Progressive enhancement for the mobile sticky bar's live line total
  (unit price x quantity). Everything else already works without this:
  - Finish switching is a real <a href="?variant="> navigation (Shopify's
    own mechanism), re-rendered server-side
  - Add to cart is a plain form post to /cart/add, and Focal's own
    `product-form`/`loader-button` elements already cover fetch, focus and
    double-submit guarding for it
  - the quantity stepper's own +/- buttons and floor-at-1 behaviour are
    Focal's own `quantity-selector`/`input-number` custom elements

  Event delegation on `document`, not per-element listeners bound once at
  load: Focal's own `product-rerender` replaces the buy-box's markup
  (including this element) whenever a variant re-renders, so a listener
  bound directly to one element would go stale. Delegating to `document`
  means it keeps working after any such replacement without rebinding.
*/
(function () {
  function unitPrice() {
    var priceEl = document.querySelector('.price-list[data-kludi-product-price] .price--large');
    if (!priceEl) return null;

    var match = priceEl.textContent.match(/[0-9][0-9,]*\.[0-9]{2}/);
    if (!match) return null;

    return parseFloat(match[0].replace(/,/g, ''));
  }

  function updateLineTotal(quantityInput) {
    var lineTotal = document.querySelector('[data-kludi-line-total]');
    var unit = unitPrice();
    if (!lineTotal || unit === null) return;

    var qty = Math.max(1, parseInt(quantityInput.value, 10) || 1);
    var total = unit * qty;
    var template = lineTotal.textContent;
    var match = template.match(/[0-9][0-9,]*\.[0-9]{2}/);
    if (!match) return;

    var formatted = total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    lineTotal.textContent = template.replace(match[0], formatted);
  }

  document.addEventListener('input', function (event) {
    var quantityInput = event.target.closest('[data-kludi-quantity-input]');
    if (quantityInput) updateLineTotal(quantityInput);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.quantity-selector__button')) return;

    var quantityInput = event.target.closest('.product-form__quantity')?.querySelector('[data-kludi-quantity-input]');
    if (!quantityInput) return;

    // Focal's own button click updates the input synchronously; read it on
    // the next tick so this runs after that update has happened
    window.setTimeout(function () {
      updateLineTotal(quantityInput);
    }, 0);
  });
})();
